import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { Tabulator } from './components/Tabulator';
import { Quickview } from './Quickview';
import { Medications } from './components/Medications';
import { Charts } from './Charts';
import { CareLocations } from './CareLocations';
import { Allergies } from './Allergies';
import { Appointments } from './Appointments';
import Labs from './Labs';
import LabsList from './LabsList';
import { Calendly } from './Calendly';
import { Symptoms } from './Symptoms';
import { IOptionsDaysBack } from '../Patient';
import { FoodTracking } from './FoodTracking';
import { ReactSelectStyles } from '../../styles/ReactSelectStyles';
import Select, { ActionMeta, components } from "react-select";
import { RbCircledChecked, RbCircledUnchecked } from '../../components/RadioButton';


const Option = (props: any) => {
  return (
    <components.Option {...props}>
      <Flex alignItems={'center'}>
        {props.isSelected ? (
          <RbCircledChecked />
        ) : <RbCircledUnchecked />}

        <Text ml={2}>{props.children}</Text>
      </Flex>
    </components.Option>
  );
};

interface IkeyInfosProps {
  id: string
  isMinimized?: boolean
}
const optionsDaysBack: Array<IOptionsDaysBack> = [
  { value: 7, label: 'Last 7 days' },
  { value: 30, label: 'Last 30 days' },
  { value: 90, label: 'Last 90 days' },
  { value: 365, label: 'Last year' },
]

const SymptomsAndFood: React.FC<IkeyInfosProps> = ({ id, isMinimized }) => {
  const [selectedTab, setSelectedTab] = useState('Symptoms')
  const [selectedPeriod, setSelectedPeriod] = useState<IOptionsDaysBack>(optionsDaysBack.find(x => x.value === 7)!)
  return (
    <Flex flexDirection={'column'}>
      {selectedTab === 'Symptoms' && (
        <>
          {!!isMinimized ? (

            <Select
              isSearchable={false}
              styles={ReactSelectStyles.initialStyles}
              options={optionsDaysBack}
              value={selectedPeriod}
              onChange={(option: IOptionsDaysBack | null, actionMeta: ActionMeta<IOptionsDaysBack>) => {
                if (!option) return
                setSelectedPeriod(option)
              }}
              components={{ Option }} />
          ) :
            <Flex justifyContent={'flex-end'} mb={3}>
              <Select
                isSearchable={false}
                styles={ReactSelectStyles.programsStyles}
                options={optionsDaysBack}
                value={selectedPeriod}
                onChange={(option: IOptionsDaysBack | null, actionMeta: ActionMeta<IOptionsDaysBack>) => {
                  if (!option) return
                  setSelectedPeriod(option)
                }}
                components={{ Option }} />
            </Flex>}
        </>
      )}

      <Tabulator isMinimized={isMinimized} onTabChanged={e => {
        setSelectedTab(e)
      }} tabs={[{
        title: 'Symptoms',
        name: 'Symptoms',
        icon: (<svg width="24" height="25" viewBox="0 0 28 29" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M21.2376 24.8224C22.1108 24.8224 22.9483 24.4793 23.5657 23.8685M21.2376 24.8224C20.3644 24.8224 19.5269 24.4793 18.9095 23.8685M21.2376 24.8224V27.2656M23.5657 23.8685C24.1832 23.2577 24.5301 22.4294 24.5301 21.5656M23.5657 23.8685L25.3125 25.5964M24.5301 21.5656C24.5301 20.7018 24.1832 19.8735 23.5657 19.2627M24.5301 21.5656H27M23.5657 19.2627C22.9483 18.6519 22.1108 18.3088 21.2376 18.3088M23.5657 19.2627L25.3125 17.5348M21.2376 18.3088C20.3644 18.3088 19.5269 18.6519 18.9095 19.2627M21.2376 18.3088V15.8656M18.9095 19.2627C18.292 19.8735 17.9452 20.7018 17.9452 21.5656M18.9095 19.2627L17.1639 17.5348M17.9452 21.5656C17.9452 22.4294 18.292 23.2577 18.9095 23.8685M17.9452 21.5656H15.4752M18.9095 23.8685L17.1639 25.5964M20.6893 15.8656H21.7872M24.9243 17.1508L25.7007 17.9188M27 21.0232V22.108M25.7007 25.2124L24.9243 25.9804M21.7872 27.2656H20.6893M17.5521 25.9804L16.7757 25.2124M15.4752 22.108V21.0232M16.7757 17.9188L17.5521 17.1508M18.8113 13.1656C18.1113 11.9646 17.0304 11.0255 15.7361 10.4938C14.4418 9.96207 13.0064 9.86738 11.6522 10.2244C10.298 10.5814 9.10061 11.3703 8.24556 12.4686C7.39051 13.567 6.92551 14.9137 6.92261 16.3V19H9.65216L10.562 28H13.9649M3.04057 4.7656L1.29123 6.7852C1.10328 7.00256 1 7.27918 1 7.5652C1 7.85122 1.10328 8.12784 1.29123 8.3452L2.36486 9.58C2.55281 9.79736 2.65609 10.074 2.65609 10.36C2.65609 10.646 2.55281 10.9226 2.36486 11.14L1.29123 12.3772C1.10328 12.5946 1 12.8712 1 13.1572C1 13.4432 1.10328 13.7198 1.29123 13.9372L2.36486 15.1756C2.55281 15.393 2.65609 15.6696 2.65609 15.9556C2.65609 16.2416 2.55281 16.5182 2.36486 16.7356L1.29123 17.98C1.10328 18.1974 1 18.474 1 18.76C1 19.046 1.10328 19.3226 1.29123 19.54L3.04057 21.5584M23.1277 11.1472C22.9397 10.9298 22.8364 10.6532 22.8364 10.3672C22.8364 10.0812 22.9397 9.80456 23.1277 9.5872L24.2013 8.3488C24.3892 8.13144 24.4925 7.85482 24.4925 7.5688C24.4925 7.28278 24.3892 7.00616 24.2013 6.7888L22.4507 4.7656M13.2855 8.2C14.2507 8.2 15.1764 7.82072 15.859 7.14558C16.5415 6.47045 16.9249 5.55478 16.9249 4.6C16.9249 3.64522 16.5415 2.72955 15.859 2.05442C15.1764 1.37928 14.2507 1 13.2855 1C12.3203 1 11.3946 1.37928 10.7121 2.05442C10.0295 2.72955 9.6461 3.64522 9.6461 4.6C9.6461 5.55478 10.0295 6.47045 10.7121 7.14558C11.3946 7.82072 12.3203 8.2 13.2855 8.2Z" stroke="#354E79" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
        </svg>

        ),
        contentWrapperStyle: {
          overflowY: 'hidden'
        },
        content: (
          <Flex flexDirection={'column'} width={'100%'} p={2}>
            <Symptoms id={id} isMinimized={isMinimized} selectedPeriod={selectedPeriod} />
          </Flex>
        )
      }, {
        title: 'Food',
        name: 'Food',
        icon: (<svg width="26" height="26" viewBox="0 0 27 27" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M20.9373 27H22.9745C24.0055 27 24.8523 26.2023 24.975 25.1959L27 4.97045H20.8636V0H18.4459V4.97045H12.3464L12.7145 7.84227C14.8132 8.41909 16.7768 9.46227 17.955 10.6159C19.7223 12.3586 20.9373 14.1627 20.9373 17.1082V27ZM0 25.7727V24.5455H18.4459V25.7727C18.4459 26.4355 17.8936 27 17.1818 27H1.22727C0.552273 27 0 26.4355 0 25.7727ZM18.4459 17.1818C18.4459 7.36364 0 7.36364 0 17.1818H18.4459ZM0 19.6364H18.4091V22.0909H0V19.6364Z" fill="#354E79" />
        </svg>

        ),
        content: (
          <Flex flexDirection={'column'} width={'100%'}>
            <FoodTracking id={id} isMinimized={isMinimized} />
          </Flex>
        )
      }
      ]} />
    </Flex>);
}

export default SymptomsAndFood


